import eventManager from '../../helpers/eventManager'

export default {
    success(...message)
    {
        eventManager.triggerEvent("MESSAGE", {
            type: "success",
            message: message
        })
    },

    error(...message)
    {
        eventManager.triggerEvent("MESSAGE", {
            type: "error",
            message: message
        })
    },

    info(...message)
    {
        eventManager.triggerEvent("MESSAGE", {
            type: "info",
            message: message
        })
    },
    
    clear()
    {
        eventManager.triggerEvent("MESSAGE-CLEAR")
    }
}
